import React, { FC } from "react"
import {
  HowMuchReimbursedModal,
  HowMuchReimbursedModalProps
} from "../../../views/reimbursements/educationmodal/HowMuchReimbursedModal"
import { useSelector } from "react-redux"
import { getCurrencySymbol } from "reducers/companyInfo"
import { getDeductibleStatus } from "reducers/deductibleStatus"
import { Moment } from "moment"
import { useFeatureToggle } from "../../../context/feature-toggle/FeatureToggleContext"
import { HowMuchMemberPartnerReimbursedModal } from "../../../views/reimbursements/educationmodal/HowMuchReimbursedMemberPartnerModal"

export type HowMuchReimbursedContainerProps = {
  planStartDate?: Moment
  planEndDate?: Moment
  deductibleAmount?: number
  externalAmountAppliedToDeductible?: number
  amountAppliedToDeductible?: number
  carrotAmountAppliedToDeductible?: number
  deductibleRemaining?: number
  currencySymbol?: string
  reimbursementPercent?: number
  companyName?: string
}

const ReimbursementStatusContext = React.createContext<HowMuchReimbursedContainerProps>({})

const HowMuchReimbursedModalContainer: FC<HowMuchReimbursedModalProps> = ({ onExit }) => {
  const { showNewEnrollmentFlow: showUpdatedDeductibleInfo } = useFeatureToggle()
  const deductibleStatus = useSelector(getDeductibleStatus)
  deductibleStatus.currencySymbol = useSelector(getCurrencySymbol)

  return (
    <ReimbursementStatusContext.Provider value={deductibleStatus}>
      {showUpdatedDeductibleInfo ? (
        <HowMuchMemberPartnerReimbursedModal onExit={onExit} />
      ) : (
        <HowMuchReimbursedModal onExit={onExit} />
      )}
    </ReimbursementStatusContext.Provider>
  )
}

export { HowMuchReimbursedModalContainer, ReimbursementStatusContext }
